module.exports = __webpack_public_path__ + "static/media/F0-React.b01ada3e.svg";